const {
  FieldType: { mediaGallery }
} = require('@wix/wix-data-schema-types')

module.exports = fieldType => (fieldType === mediaGallery ? [] : undefined)
